import React, { Component } from 'react'
import { connect } from 'react-redux'
import {
  withStyles,
  ExpansionPanel,
  ExpansionPanelSummary,
  Typography,
  Avatar,
  Grid,
  Hidden,
} from '@material-ui/core'
import styles from './styles'
import language from 'utils/vast-languagepack'

export default connect(state => ({
  responses: state.signupForm.forms[state.signupForm.addOrEdit.formID]?.signups,
  formTypeSelected: state.signupForm.addOrEdit.formTypeSelected,
}))(
  withStyles(styles)(
    class Responses extends Component {
      state = { expanded: null }

      render() {
        const { classes, responses, formTypeSelected } = this.props
        const { expanded } = this.state

        if (
          formTypeSelected === 'custom' ||
          formTypeSelected === 'customIntegration'
        ) {
          return null
        }

        return (
          <Grid item xs={12}>
            <div
              style={
                null /*{ textAlign: 'center', flexGrow: 1, overflow: 'hidden' }*/
              }
            >
              {responses?.length ? (
                responses.map((response, idx) => {
                  const style = () => {
                    if (expanded === idx - 1) {
                      return {
                        borderTopLeftRadius: 35,
                        borderTopRightRadius: 35,
                      }
                    } else if (expanded === idx + 1) {
                      return {
                        borderBottomLeftRadius: 35,
                        borderBottomRightRadius: 35,
                      }
                    } else {
                      return {}
                    }
                  }

                  return (
                    <ExpansionPanel
                      classes={{
                        root: classes.expansionPanelRoot,
                        expanded: classes.expansionPanelExpanded,
                      }}
                      key={`responsePanel-${response.contact_id}`}
                      expanded={expanded === idx}
                      onChange={(event, expanded) =>
                        this.setState({ expanded: expanded ? idx : null })
                      }
                      style={style()}
                    >
                      <ExpansionPanelSummary
                        classes={{ content: classes.expandPanelSummary }}
                      >
                        <div className={classes.expandPanelIcon}>
                          <Avatar>
                            {`${response.contact_method
                              .slice(0, 1)
                              .toUpperCase()}`}
                          </Avatar>
                        </div>
                        <Hidden mdUp>
                          <div
                            className={classes.heading}
                            style={{ position: 'relative' }}
                          >
                            <span
                              style={{
                                display: 'table-cell',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                              }}
                            >
                              {response.contact_method}
                            </span>
                            <span
                              style={{
                                fontWeight: 'normal',
                                position: 'absolute',
                                left: 0,
                                top: 15,
                                fontSize: 12,
                              }}
                            >
                              {response.timestamp
                                ? new Date(response.timestamp).toLocaleString()
                                : 'unknown date'}
                            </span>
                          </div>
                        </Hidden>
                        <Hidden smDown>
                          <div className={classes.heading}>
                            <span
                              style={{
                                display: 'table-cell',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                              }}
                            >
                              {response.contact_method}
                              <span style={{ fontWeight: 'normal' }}>
                                {' '}
                                -{' '}
                                {response.timestamp
                                  ? new Date(
                                      response.timestamp,
                                    ).toLocaleString()
                                  : 'unknown date'}
                              </span>
                            </span>
                          </div>
                        </Hidden>
                        {/* <div className={classes.secondaryHeading}>
                          {language.signupform.add.responded}
                        </div> */}
                      </ExpansionPanelSummary>
                      {/* <ExpansionPanelDetails>
                      
                    </ExpansionPanelDetails> */}
                    </ExpansionPanel>
                  )
                })
              ) : (
                <Typography variant="h4" gutterBottom>
                  {language.signupform.add.responses.noResponses}
                </Typography>
              )}
            </div>
          </Grid>
        )
      }
    },
  ),
)
